import { getCardRegistry } from '@/lib/cards';
import { CategoryCountsCard } from './CategoryCountsCard';
import { MailboxInsightCard } from './MailboxInsightCard';
import { SLA7dCard } from './SLA7dCard';
import { SLA30dCard } from './SLA30dCard';
import { LatestDigestCard } from './LatestDigestCard';

/**
 * Register all dashboard card components
 * Call this during app initialization
 */
export function registerDashboardCardComponents() {
  const registry = getCardRegistry();

  registry.register('dashboard.category_counts', CategoryCountsCard);
  registry.register('dashboard.mailbox_insight', MailboxInsightCard);
  registry.register('dashboard.sla_7d', SLA7dCard);
  registry.register('dashboard.sla_30d', SLA30dCard);
  registry.register('dashboard.latest_digest', LatestDigestCard);
}

export {
  CategoryCountsCard,
  MailboxInsightCard,
  SLA7dCard,
  SLA30dCard,
  LatestDigestCard,
};
